import { render } from "./UserActivityLogListPage.vue?vue&type=template&id=42473dbe"
import script from "./UserActivityLogListPage.vue?vue&type=script&lang=js"
export * from "./UserActivityLogListPage.vue?vue&type=script&lang=js"
script.render = render

export default script